/*
  Strings added with the workspace design v2 (dashboard live clicks).
  Merged into TRANSLATION_MAPS in ./index.js.
*/

const ru = {
  'Live clicks': 'Клики в реальном времени',
  'Open clicks log': 'Открыть лог кликов',
  'Could not load clicks': 'Не удалось загрузить клики',
  'No clicks yet': 'Кликов пока нет',
  'Send traffic to a tracking link and every click shows up here as it happens.': 'Отправьте трафик на трекинговую ссылку, и каждый клик появится здесь сразу же.',
  cloaked: 'клоака',
  proxy: 'прокси',
  human: 'человек',
  '{n}s ago': '{n} с назад',
  '{n} min ago': '{n} мин назад',
  '{n} h ago': '{n} ч назад',
  Trend: 'Тренд',
  'Clicks, last 14 days': 'Клики за 14 дней',
  'Add level': 'Добавить уровень',
  'Remove level': 'Убрать уровень',
  'Last {n} days': 'Последние {n} дн.',
  'All time': 'Всё время',
  'JA3 / JA4 fingerprint overrides for bot detection': 'Ручная разметка отпечатков JA3 / JA4 для поиска ботов',
  'Uptime, DB size, data-processing queue and host metrics': 'Аптайм, размер базы, очередь обработки данных и метрики сервера',
  'Outbound conversion postbacks fired across your campaigns': 'Исходящие постбэки конверсий по всем кампаниям',
  "Normal — a regular stream with filters. Catch (intercepting) — checked before Normal streams and takes a matching click first, e.g. bots or a test GEO. Fallback — the last stream; it gets traffic that matched nothing else.": "Обычный — поток с фильтрами. Перехватывающий — проверяется раньше обычных и первым забирает подходящий клик, например ботов или тестовое ГЕО. Замыкающий — последний поток, получает трафик, который не подошёл никуда.",
  "Interface: search, shortcuts and language": "Интерфейс: поиск, горячие клавиши и язык",
  "Postbacks": "Постбэки",
  "Macros": "Макросы",
  "CAPI": "CAPI",
  "FAQ": "Частые вопросы",
  "Cost, integrations & ops": "Расходы, интеграции и эксплуатация",
  "Audience": "Аудитория",
  "New campaign": "Новая кампания",
  "Command palette": "Поиск и команды",
  "Pre-landing page": "Прелендинг",
  "good": "хороший",
  "bad": "плохой",
  "unknown": "неизвестный",
  "Chargeback (reject)": "Чарджбэк (отклонение)",
  "Something went wrong on our end. Please try again later or contact support.": "Что-то пошло не так на нашей стороне. Попробуйте позже или напишите в поддержку.",
  "Static pages for bots/ad review — hosted here, served same-origin on your domain (Google-safe cloaking)": "Статичные страницы для ботов и модерации рекламы — хранятся здесь и отдаются с вашего домена (безопасная для Google клоака)",
};

const es = {
  'Live clicks': 'Clics en vivo',
  'Open clicks log': 'Abrir registro de clics',
  'Could not load clicks': 'No se pudieron cargar los clics',
  'No clicks yet': 'Aún no hay clics',
  'Send traffic to a tracking link and every click shows up here as it happens.': 'Envía tráfico a un enlace de seguimiento y cada clic aparecerá aquí al instante.',
  cloaked: 'cloaking',
  proxy: 'proxy',
  human: 'humano',
  '{n}s ago': 'hace {n} s',
  '{n} min ago': 'hace {n} min',
  '{n} h ago': 'hace {n} h',
  Trend: 'Tendencia',
  'Clicks, last 14 days': 'Clics, últimos 14 días',
  'Add level': 'Añadir nivel',
  'Remove level': 'Quitar nivel',
  'Last {n} days': 'Últimos {n} días',
  'All time': 'Todo el tiempo',
  'JA3 / JA4 fingerprint overrides for bot detection': 'Clasificación manual de huellas JA3 / JA4 para detectar bots',
  'Uptime, DB size, data-processing queue and host metrics': 'Disponibilidad, tamaño de la base, cola de procesamiento y métricas del servidor',
  'Outbound conversion postbacks fired across your campaigns': 'Postbacks de conversión salientes de todas tus campañas',
  "Normal — a regular stream with filters. Catch (intercepting) — checked before Normal streams and takes a matching click first, e.g. bots or a test GEO. Fallback — the last stream; it gets traffic that matched nothing else.": "Normal — flujo con filtros. Captura — se revisa antes que los normales y se queda primero con el clic que coincide, por ejemplo bots o un GEO de prueba. Respaldo — el último flujo; recibe el tráfico que no coincidió con nada.",
  "Interface: search, shortcuts and language": "Interfaz: búsqueda, atajos e idioma",
  "Postbacks": "Postbacks",
  "Macros": "Macros",
  "CAPI": "CAPI",
  "FAQ": "Preguntas frecuentes",
  "Cost, integrations & ops": "Costes, integraciones y operación",
  "Audience": "Audiencia",
  "New campaign": "Nueva campaña",
  "Command palette": "Búsqueda y comandos",
  "Pre-landing page": "Pre-landing",
  "good": "bueno",
  "bad": "malo",
  "unknown": "desconocido",
  "Chargeback (reject)": "Contracargo (rechazo)",
  "Something went wrong on our end. Please try again later or contact support.": "Algo salió mal por nuestra parte. Inténtalo más tarde o contacta con soporte.",
  "Static pages for bots/ad review — hosted here, served same-origin on your domain (Google-safe cloaking)": "Páginas estáticas para bots y revisión de anuncios — alojadas aquí y servidas desde tu dominio (cloaking seguro para Google)",
};

const pt = {
  'Live clicks': 'Cliques ao vivo',
  'Open clicks log': 'Abrir registro de cliques',
  'Could not load clicks': 'Não foi possível carregar os cliques',
  'No clicks yet': 'Ainda não há cliques',
  'Send traffic to a tracking link and every click shows up here as it happens.': 'Envie tráfego para um link de rastreamento e cada clique aparece aqui na hora.',
  cloaked: 'cloaking',
  proxy: 'proxy',
  human: 'humano',
  '{n}s ago': 'há {n} s',
  '{n} min ago': 'há {n} min',
  '{n} h ago': 'há {n} h',
  Trend: 'Tendência',
  'Clicks, last 14 days': 'Cliques, últimos 14 dias',
  'Add level': 'Adicionar nível',
  'Remove level': 'Remover nível',
  'Last {n} days': 'Últimos {n} dias',
  'All time': 'Todo o período',
  'JA3 / JA4 fingerprint overrides for bot detection': 'Classificação manual de impressões JA3 / JA4 para detectar bots',
  'Uptime, DB size, data-processing queue and host metrics': 'Disponibilidade, tamanho do banco, fila de processamento e métricas do servidor',
  'Outbound conversion postbacks fired across your campaigns': 'Postbacks de conversão enviados de todas as suas campanhas',
  "Normal — a regular stream with filters. Catch (intercepting) — checked before Normal streams and takes a matching click first, e.g. bots or a test GEO. Fallback — the last stream; it gets traffic that matched nothing else.": "Normal — fluxo com filtros. Capturar — é verificado antes dos normais e fica primeiro com o clique que coincide, por exemplo bots ou um GEO de teste. Fallback — o último fluxo; recebe o tráfego que não coincidiu com nada.",
  "Interface: search, shortcuts and language": "Interface: busca, atalhos e idioma",
  "Postbacks": "Postbacks",
  "Macros": "Macros",
  "CAPI": "CAPI",
  "FAQ": "Perguntas frequentes",
  "Cost, integrations & ops": "Custos, integrações e operação",
  "Audience": "Público",
  "New campaign": "Nova campanha",
  "Command palette": "Busca e comandos",
  "Pre-landing page": "Pré-landing",
  "good": "bom",
  "bad": "ruim",
  "unknown": "desconhecido",
  "Chargeback (reject)": "Estorno (rejeição)",
  "Something went wrong on our end. Please try again later or contact support.": "Algo deu errado do nosso lado. Tente novamente mais tarde ou fale com o suporte.",
  "Static pages for bots/ad review — hosted here, served same-origin on your domain (Google-safe cloaking)": "Páginas estáticas para bots e revisão de anúncios — hospedadas aqui e servidas no seu domínio (cloaking seguro para o Google)",
};

const DESIGN_EXTRA = { ru, es, pt };
export default DESIGN_EXTRA;
